module.exports = __webpack_public_path__ + "img/zhuanli2.57614b6c.png";